import { getListOfCountries } from 'modules/Auth/actions'
import authSelector from 'modules/Auth/selectors'
import NewRoleCreation from 'modules/Roles/NewRoleCreation'
import {
  createQuestionarie,
  createQuestionarieBank,
  deleteQuestion,
  editQuestionarie,
  getAllQuestionBankList,
  getAllQuestionarieList,
  getCities,
  getDesignationsList,
  getElasticSearchDegreeData,
  getFunctionsList,
  getInstitutesList,
  getInstitutesLocationList,
  getJobRoleCampusList,
  getListOfDegree,
  getListOfSkills,
  getRoleCityData,
  getRoleDraftData,
  getSingleQuestionarie,
  getSingleRoleData,
  getSpecialisationList,
  newCorporateJobRoles,
  publishCorporateJobRole,
  setCurrentJobId,
  setDraftData,
  setSingleQuestionarie,
  updateCorporateJobRoles,
  getEligibilityCriteriaQualification,
} from 'modules/Roles/actions'
import rolesSelectors from 'modules/Roles/selectors'
import { getNotificationCatalogues } from 'modules/Users/actions'
import { connect } from 'react-redux'
import {
  getCourses,
  getLocations,
  getPreviewData,
  getYearOfPassing,
  postCorporateJobRole,
  updateJobRole,
  createCorporateInstituteDetails,
  createDraftSelectInstitute,
  createGroup,
  deleteGroup,
  dublicateGroup,
  getMatchedInstituteList,
  getMatchedInstituteListFilter,
  getSelectedInstitutes,
  getSelectedInstitutesFilter,
  groupInstituteListFilter,
  instituteGroupList,
  oneGroupDetail,
  removeInstituteFromGroup,
  updateCorporateInstituteDetails,
  updateGroup,
  getMapMetrics,
  publishRole,
  deleteSelectedDraftInstitute,
  getStepper,
  setSingleRoleData,
} from '../../actions'
import selectors from '../../selectors'
import { getUserList } from '../../../Users/actions'
import { corporateDetails } from '../../../Auth/actions'

const mapStateToProps = state => ({
  previewRoleData: rolesSelectors.getPreviewRoleData(state),
  currentJobId: rolesSelectors.getCurrentJobId(state),
  corporateId: authSelector.getCorporateId(state),
  institutesList: rolesSelectors.getInstitutesList(state),
  singleRoleData: rolesSelectors.getSingleRoleData(state),
  isEditingRole: rolesSelectors.getIsEditingRole(state),
  listOfDegree: rolesSelectors.getListOfDegree(state),
  listOfSkills: rolesSelectors.getListOfSkills(state),
  designationsList: rolesSelectors.getDesignationList(state),
  functionsList: rolesSelectors.getFunctionsList(state),
  listOfCities: rolesSelectors.getListOfCities(state),
  isEditRoleOnView: rolesSelectors.getEditRoleOnView(state),
  specialisationList: rolesSelectors.getSpecialisationListData(state),
  corporateData: authSelector.getCorporateData(state),
  permissions: authSelector.getUserPermissions(state),
  allQuestionarieList: selectors.getAllQuestionarieList(state),
  singleQuestion: selectors.getSingleQuestionarie(state),
  allQuestionBankList: selectors.getAllQuestionBankList(state),
  institutesLocationList: selectors.getInstitutesLocationList(state),
  draftData: rolesSelectors.getRoleDraftData(state),
  elasticSearchData: rolesSelectors.elasticSearchData(state),
  questionAndAnswerList: rolesSelectors.questionAnswerList(state),
  locationList: rolesSelectors.getLocations(state),
  corporateData: authSelector.getCorporateData(state),
  roleDetails: rolesSelectors.getRoleDetails(state),
  yearOfPassing: rolesSelectors.getYearOfPassing(state),
})

const mapDispatchToProps = {
  setDraftData,
  getRoleCityData,
  newCorporateJobRoles,
  getInstitutesList,
  publishCorporateJobRole,
  updateCorporateJobRoles,
  setCurrentJobId,
  getListOfDegree,
  getListOfSkills,
  getDesignationsList,
  getFunctionsList,
  getCities,
  getSingleRoleData,
  getSpecialisationList,
  getJobRoleCampusList,
  getListOfCountries,
  getNotificationCatalogues,
  createQuestionarie,
  getAllQuestionarieList,
  deleteQuestion,
  editQuestionarie,
  getSingleQuestionarie,
  setSingleQuestionarie,
  getAllQuestionBankList,
  createQuestionarieBank,
  getInstitutesLocationList,
  getRoleDraftData,
  getElasticSearchDegreeData,
  getLocations,
  getUserList,
  postCorporateJobRole,
  updateJobRole,
  getYearOfPassing,
  getEligibilityCriteriaQualification,
  getCourses,
  createGroup,
  updateGroup,
  deleteGroup,
  oneGroupDetail,
  removeInstituteFromGroup,
  getMatchedInstituteList,
  instituteGroupList,
  createDraftSelectInstitute,
  getSelectedInstitutes,
  updateCorporateInstituteDetails,
  createCorporateInstituteDetails,
  dublicateGroup,
  getMatchedInstituteListFilter,
  groupInstituteListFilter,
  getSelectedInstitutesFilter,
  getPreviewData,
  getMapMetrics,
  publishRole,
  deleteSelectedDraftInstitute,
  getStepper,
  corporateDetails,
  setSingleRoleData,
}

export default connect(mapStateToProps, mapDispatchToProps)(NewRoleCreation)
